import { render, staticRenderFns } from "./StockProduct.vue?vue&type=template&id=a39dec6c&"
import script from "./StockProduct.vue?vue&type=script&lang=js&"
export * from "./StockProduct.vue?vue&type=script&lang=js&"
import style0 from "./StockProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports